import React, { useEffect, useState } from "react";
import axios from "axios";
import "./style.css";
import {
  Form,
  Input,
  Col,
  Row,
  Spin,
  Button,
  Space,
  DatePicker,
  Select,
  InputNumber,
  Tooltip,
  Divider
} from "antd";
import { LinkOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { colors } from "../../../utils/colors";
import { dateFormat } from "../../../utils/helpers";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import { RoutesLookup } from '../../../../Routes/RoutesLookup';
import {
  GET_REWARD_BYID
} from '../../../../API/paths';
import { DATAGRID_DEFAULT_PAGE_SIZE } from '../../../../Constants/ApplicationConstants';
import RewardImages from './RewardImages';

const { Option } = Select;

const ViewRewardForm = ({
  id,
  form,
  categories,
  loading,
  statusType,
  returnPage,
  returnPageSize,
}) => {
  const navigate = useNavigate();
  const [, setDate] = useState();
  const [featuredImagePath, setFeaturedImagePath] = useState();
  const [imagesPath, setImagesPath] = useState();
  const commonPaginationParams = `?page=${returnPage ?? 1}&pageSize=${returnPageSize ?? DATAGRID_DEFAULT_PAGE_SIZE
    }&statusType=${statusType ?? undefined}`;

  const getDataById = async (rewardId) => {
    try {
      const response = await axios.get(`${GET_REWARD_BYID}?Id=${rewardId}`);
      const result = response?.data?.result;
      setDate(result);
      
      if (!result.ARLR_Images_Path) {
        result["ARLR_Images_Path"] = [];
      }
      if (result?.ARLR_Image_Path) {
        result?.ARLR_Images_Path?.unshift(result.ARLR_Image_Path)
      } else if (result.ARLR_Images_Path?.length > 0) {
        result["ARLR_Image_Path"] = result.ARLR_Images_Path[0];
      }

      setFeaturedImagePath(() => result?.ARLR_Image_Path);
      setImagesPath(() => result?.ARLR_Images_Path);
      form.setFieldsValue({
        reward_name: result?.ARLR_Title,
        description: result?.ARLR_Description,
        reward_source: result?.ARLR_Source,
        cost: result?.ARLR_Cost,
        comment: result?.ARLR_Comment,
        reward_category: result?.ARLR_Category_ARLC_KeyID,
        quantity: result?.ARLR_Quantity,
        saveType: result?.ARLR_Status,
        radeem_on_points: result?.ARLR_Norm_Points,
        status: result?.ARLR_Is_Active,
        reward_image: result?.ARLR_Image_Path,
        reward_images: result?.ARLR_Images_Path,
        featured: result?.ARLR_Is_Featured,
        redeemablequantity: result?.ARLR_Redeemable_Quantity,
        start_date: dayjs(
          dateFormat(result?.ARLR_Start_Date, "MM-DD-YYYY"),
          "MM-DD-YYYY"
        ),
        expiry_date: result?.ARLR_Expiry_Date
          ? dayjs(
            dateFormat(result?.ARLR_Expiry_Date, "MM-DD-YYYY"),
            "MM-DD-YYYY"
          )
          : "",
      });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (id !== "create") {
      getDataById(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigateToUrl = () => {
    let url = form.getFieldValue("reward_source");
    if (url && !url.startsWith("http://") && !url.startsWith("https://")) {
      url = "https://" + url;
    }
    if (url) {
      window.open(url, "_blank");
    }
  }

  return (
    <Spin spinning={loading}>
      <Form
        form={form}
        layout="vertical"
        className='edit-reward'
      >
        <Row
          style={{
            position: "relative",
          }}
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
        >
          <Col className="gutter-row" span={12}>
          <Button
                    type="primary"
                    onClick={() => {
                      navigate(
                        `${RoutesLookup.REWARD_INVENTORY}/${id}${commonPaginationParams}`
                      );
                    }}
                  >
                    Edit Item
                  </Button>
                <Divider/>
            <Form.Item
              label="Reward Name"
              name="reward_name"
            >
              <Input size="large" disabled />
            </Form.Item>
            <Form.Item
              label="Reward Category"
              name="reward_category"
            >
              <Select
                disabled
                size="large"
              >
                {categories?.map((item) => (
                  <Option key={item?.ARLC_KeyID} value={item.ARLC_KeyID}>
                    {item.ARLC_Title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Add Description"
              name="description"
            >
              <TextArea
                style={{ minHeight: 150 }}
                size="large"
                disabled
              />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  Gift Purchase Source
                  <Tooltip title="Go to URL">
                    <Button
                      type="link"
                      icon={<LinkOutlined />}
                      onClick={navigateToUrl}
                      style={{ padding: '0 5px' }}
                    />
                  </Tooltip>
                </span>
              }
              name="reward_source"
            >
              <Input
                type="text"
                size="large"
                disabled
              />
            </Form.Item>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
            >
              <Col span={12}>
                <Form.Item
                  label="Quantity"
                  name="quantity"
                >
                  <Input
                    type="number"
                    size="large"
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Cost"
                  name="cost"
                >
                  <InputNumber
                    type='number'
                    size="large"
                    disabled
                    controls={false}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Redeem On Points"
                  name="radeem_on_points"
                >
                  <Input
                    type="number"
                    size="large"
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
            >
              <Col className="gutter-row" span={12}>
                <Form.Item
                  label="Start date"
                  name="start_date"
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    size="large"
                    format="MM-DD-YYYY"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={12}>
                <Form.Item
                  label="Expiry date"
                  name="expiry_date"
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    size="large"
                    format="MM-DD-YYYY"
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label="Status"
              name="status"
            >
              <Select disabled size="large">
                <Option value={true}>Active</Option>
                <Option value={false}>Inactive</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Featured"
              name="featured"
            >
              <Select disabled size="large">
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
            <div>
              <Form.Item
                label="Maximum Redeemable Quantity"
                name="redeemablequantity"
              >
                <Input
                  type="number"
                  size="large"
                  disabled
                />
              </Form.Item>
              <Form.Item
                label="Admin Comment"
                name="comment"
              >
                <TextArea
                  style={{ minHeight: 150 }}
                  size="large"
                  disabled
                />
              </Form.Item>
            </div>
            <Row>
              <Col
                span={24}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  marginTop: 50,
                }}
              >
                <Space direction="horizontal" size={20}>
                  <Button
                    style={{ color: colors.black }}
                    type="default"
                    onClick={() => {
                      navigate(
                        `${RoutesLookup.REWARD_INVENTORY}${commonPaginationParams}`
                      );
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate(
                        `${RoutesLookup.REWARD_INVENTORY}/${id}${commonPaginationParams}`
                      );
                    }}
                  >
                    Edit Item
                  </Button>
                </Space>
              </Col>
            </Row>
          </Col>
          <Col className="gutter-row" span={12}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Row style={{ width: "100%" }}>
                <Col span={24}>
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <Form.Item name="reward_images" style={{ margin: 0 }}>
                      <RewardImages form={form} featuredImagePath={featuredImagePath} imagesPath={imagesPath} />
                    </Form.Item>
                    <Form.Item name="reward_image" />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default ViewRewardForm;